import CryptoJS from 'crypto-js';
const secretKey =
  'Empowering Small and Medium Enterprises with customized financing solutions';

export const encryptData = (data) => {
  return CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
};

export const decryptData = (data) => {
  const bytes = CryptoJS.AES.decrypt(data, secretKey);
  return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
};

// export const EmailValidation = (value) => {
//   const regex =
//     /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
//   return regex.test(value);
// };

export const EmailValidation = (value) => {
  const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i;
  return regex.test(value);
};

export const PasswordValidation = (password) => {
  const checks = {
    length: password.length >= 8 && password.length <= 16,
    upper: /[A-Z]/.test(password),
    lower: /[a-z]/.test(password),
    number: /[0-9]/.test(password),
    special: /[!@#$%^&*(),.?":{}|<>]/.test(password),
  };

  const missing = [];

  if (!checks.length) missing.push('8–16 characters');
  if (!checks.upper) missing.push('1 uppercase');
  if (!checks.lower) missing.push('1 lowercase');
  if (!checks.number) missing.push('1 number');
  if (!checks.special) missing.push('1 special character');

  return {
    isValid: missing.length === 0,
    missing,
  };
};

export const PhoneNumberValidation = (value) => {
  const regex = /^(\d{8}(\,\d{8}){0,2})$/;
  return regex.test(value);
};
